// TypeScript
import React from 'react';
import { FilterButton } from 'types/filter-button';
import FilterBtnWhite from 'components/partials/buttons/filter-btn-white';

type TabbedBannerProps = {
    title: string;
    filterButtons: FilterButton[];
};

const TabbedBanner: React.FC<TabbedBannerProps> = ({ title, filterButtons }) => (
    <div className="pattern pattern--pad pattern--tabbed-banner">
        <div className="container">
            <h1 className="large-title">{title}</h1>
            {filterButtons.map((button, index) => (
                <FilterBtnWhite key={index} modifierClass={button.modifierClass} buttonText={button.buttonText} isActive={button.isActive} onClick={button.onClick} />
            ))}
        </div>
    </div>
);

export default TabbedBanner;